import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  TimeScale,
  BarElement,
  LineElement,
  PointElement,
  ArcElement,
  Filler,
  Legend,
  Title,
  Tooltip,
} from "chart.js";
import "chartjs-adapter-date-fns";
import { isDarkMode } from "./darkMode";

// Registers the Chart.js building blocks used across the portal's chart.js
// graphs. react-chartjs-2's typed components register their own controllers,
// so only scales, elements and plugins are registered here.
//
ChartJS.register(
  CategoryScale,
  LinearScale,
  TimeScale,
  BarElement,
  LineElement,
  PointElement,
  ArcElement,
  Filler,
  Legend,
  Title,
  Tooltip,
);

// Concrete colors mirroring the CSS variables the Highcharts configs use.
// Canvas cannot resolve CSS variables, so hex values are required.
export const chartColors = {
  blueHighcharts: "#7cb5ec",
  yellow: "#ffbd01",
  darkBlue: "#02304b",
  white: "#ffffff",
  green: "#50c878",
};

export const chartJsTextColor = (): string => (isDarkMode() ? "#f7f8f9" : "#02304b");
export const chartJsGridColor = (): string => (isDarkMode() ? "#374151" : "#e5e7eb");
